// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16K3b","fullView":"styles_fullView__RGHD5"};